import classes from "./styles.module.scss";
import Link from 'next/link';
import ArrowRight2 from "@/assets/ArrowRight2.svg";

export default function Button({ display, variant, link = '', className, icon, onClick }) {
  return (
     <Link href={link} passHref className={classes.link}>
        <button className={`${className} ${classes.button} btn-${variant}`} onClick={onClick}>
          {display}
          {
            icon &&
            <ArrowRight2 width={16} height={16} className={`fill ${variant} ${classes.icon}`} />
          }
        </button>
     </Link>
  );
}

Button.defaultProps = {
  className: "",
};
